import { Component, ElementRef, HostListener, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';

import SwiperCore, {
  Autoplay,
  Keyboard,
  Navigation,
  Pagination,
  Scrollbar,
  Zoom,
  SwiperOptions,
} from 'swiper';
import { RestService } from 'src/app/services/rest.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
SwiperCore.use([Autoplay, Keyboard, Navigation, Pagination, Scrollbar, Zoom]);
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit, AfterViewInit, OnDestroy {
  category: any;
  products: any;
  allPackages: any;
  ifPackages = false;
  topProducts: any[] = [];
  featuredProduct: any = null;

  bsSwiperConfig: SwiperOptions = {
    slidesPerView: 4,
    centeredSlides: true,
    spaceBetween: 18,
    loop: true,
    autoplay: { delay: 3800, disableOnInteraction: false },
    pagination: { clickable: true },
    navigation: true,
    breakpoints: {
      0:   { slidesPerView: 1.6, spaceBetween: 12 },
      576: { slidesPerView: 2.5, spaceBetween: 14 },
      991: { slidesPerView: 4, spaceBetween: 18 },
    },
  };
  constructor(
    private rest: RestService,
    private route: Router,
    private _sanitizer: DomSanitizer
  ) {}

  @ViewChild('potwSection') private potwSection?: ElementRef<HTMLElement>;
  @ViewChild('potwParallaxBg') private potwParallaxBg?: ElementRef<HTMLElement>;
  @ViewChild('catRailTrack') private catRailTrack?: ElementRef<HTMLElement>;

  private observer!: IntersectionObserver;
  private catRailScrollHandler = () => this.updateActiveCatTile();

  @HostListener('window:scroll')
  onScroll(): void {
    if (!this.potwParallaxBg || !this.potwSection) return;
    const rect = this.potwSection.nativeElement.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > window.innerHeight) return;
    const offset = -rect.top * 0.30;
    this.potwParallaxBg.nativeElement.style.transform = `translateY(${offset}px)`;
  }

  ngOnInit() {
    this.getData();
  }

  ngAfterViewInit() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            (entry.target as HTMLElement).classList.add('revealed');
            this.observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -48px 0px' }
    );
    this.attachObserver();

    if (this.catRailTrack) {
      this.catRailTrack.nativeElement.addEventListener('scroll', this.catRailScrollHandler, { passive: true });
    }
  }

  ngOnDestroy() {
    if (this.catRailTrack) {
      this.catRailTrack.nativeElement.removeEventListener('scroll', this.catRailScrollHandler);
    }
  }

  private attachObserver() {
    document.querySelectorAll('.scroll-reveal').forEach(el => this.observer.observe(el));
  }

  // Marks whichever category tile is closest to the rail's center as active —
  // the touch/swipe equivalent of :hover, since the rail only scrolls below
  // 1200px (see home.component.scss) where hover never fires.
  private updateActiveCatTile() {
    const track = this.catRailTrack?.nativeElement;
    if (!track) return;
    const tiles = Array.from(track.querySelectorAll<HTMLElement>('.cat-rail-tile'));
    if (!tiles.length) return;

    const trackRect = track.getBoundingClientRect();
    const center = trackRect.left + trackRect.width / 2;

    let closest = tiles[0];
    let closestDist = Infinity;
    tiles.forEach(tile => {
      const r = tile.getBoundingClientRect();
      const dist = Math.abs(r.left + r.width / 2 - center);
      if (dist < closestDist) {
        closestDist = dist;
        closest = tile;
      }
    });

    tiles.forEach(t => t.classList.toggle('is-active', t === closest));
  }

  effectivePrice(product: any): number {
    if (!product.discount || product.discount <= 0) return product.price;
    return Math.round(product.price * (100 - product.discount) / 100);
  }

  featuredEffectivePrice(product: any): number {
    return this.effectivePrice(product);
  }

  getData() {
    this.rest.homePage().subscribe((res: any) => {
      this.category = res.categories;
      this.products = res.products;
      this.allPackages = res.packages;

      if (res.featured_product) {
        const fp = res.featured_product;
        if (fp.images && fp.images.length > 0) {
          fp.images[0].image_url = `${environment.apiUrl}/images/?id=${fp.images[0].image_url}`;
        } else {
          fp.images = [{ image_url: 'assets/images/rk.jpeg' }];
        }
        this.featuredProduct = fp;
      }

      if (this.allPackages.length != 0) {
        this.ifPackages = true;
      } else {
        this.ifPackages = false;
      }

      this.category.forEach((element: any) => {
        if (element.image != null) {
          element.image.image_url = `${environment.apiUrl}/images/?id=${element.image.image_url}`;
        } else {
          element.image = {
            image_url: 'assets/images/rk.jpeg',
          };
        }
      });

      this.products.forEach((element: any) => {
        if (element.images.length != 0) {
          element.images[0].image_url = `${environment.apiUrl}/images/?id=${element.images[0].image_url}`;
        } else {
          element.image = { image_url: 'assets/images/rk.jpeg' };
        }
      });

      this.topProducts = this.products.slice(0, 5);

      this.allPackages.forEach((element: any) => {
        if (element.image != null) {
          element.image = `${environment.apiUrl}/images/?id=${element.image}`;
        } else {
          element.image = 'assets/images/rk.jpeg';
        }
      });

      setTimeout(() => {
        this.attachObserver();
        this.updateActiveCatTile();
      }, 80);
    });
  }

  pack_details(id: any) {
    this.route.navigate(['/packges_details', id]);
  }
}
